import { GridColumnConfig } from '../../../models/gridCoumnConfig';

export const columns: GridColumnConfig[] = [
  {
    title: 'Sort Order',
    field: 'sortOrder',
    filter: 'text',
    editable: true,
    editor: 'numeric',
    width: '110',
    searchable: true,
  },
  {
    title: 'Service Name',
    field: 'serviceName',
    filter: 'text',
    searchable: true,
    width: '220',
  },
  {
    title: 'Service Code',
    field: 'serviceCode',
    filter: 'text',
    searchable: true,
    width: '220',
  },
  {
    title: 'Service Group',
    field: 'serviceGroupName',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  { 
    title: 'Service Category',
    field: 'serviceCategoryName',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'Service Type (Fastfield Service Category = PPI Only)',
    field: 'serviceTypeName',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Service Type (Fastfield Service Category != PPI Only)',
    field: 'notPPIOnlyServiceTypeName',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  
  {
    title: '1-Story Predecessor',
    field: 'oneStoryPredecessorNames',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: '2-Story Predecessor',
    field: 'twoStoryPredecessorNames',
    filter: 'text',
    searchable: true,
    width: '200',
  },
  {
    title: 'Billing Type',
    field: 'billingType',
    filter: 'text',
    searchable: true,
    width: '140',
  },
  {
    title: 'Invoice Amount',
    field: 'price',
    filter: 'numeric',
    searchable: true,
    width: '140',
  },
  // {
  //   title: 'Accrual Amount',
  //   field: 'accrualAmount',
  //   filter: 'numeric',
  //   searchable: true,
  //   width: '140',
  // },
  // {
  //   title: 'Sort Order',
  //   field: 'sortOrder',
  //   filter: 'text',
  //   editable: true,
  //   editor: 'numeric',
  //   width: '110',
  // },

  {
    title: 'Market Areas',
    field: 'marketAreaNames',
    filter: 'text',
    searchable: true,
    width: '150',
  },
  {
    title: 'Status',
    field: 'status',
    filter: 'boolean',
    searchable: true,
    width: '90',
  },
];
